import { render, staticRenderFns } from "./VariantPickerSubmitButton.vue?vue&type=template&id=74ad10dc&scoped=true&"
import script from "./VariantPickerSubmitButton.vue?vue&type=script&lang=js&"
export * from "./VariantPickerSubmitButton.vue?vue&type=script&lang=js&"
import style0 from "./VariantPickerSubmitButton.vue?vue&type=style&index=0&id=74ad10dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74ad10dc",
  null
  
)

export default component.exports